<div class="dialog-container">
  <lib-dialog-header (closeClick)="closeClicked()">
    {{ config()?.title ?? '' }}
  </lib-dialog-header>
  <div class="dialog-content">
    {{ config()?.messageAboveList ?? '' }}
    <div class="dialog-list">
      @for (listItem of config()?.list; track $index) {
        <div class="dialog-list-item">
          {{ listItem }}
        </div>
      }
    </div>
    {{ config()?.messageBelowList ?? '' }}
  </div>
  <div class="dialog-footer">
    <lib-button [type]="ButtonType.secondary" (buttonClick)="secondaryButtonClicked()">
      {{ config()?.secondaryButtonText ?? '' }}
    </lib-button>
    <lib-button [type]="ButtonType.primary" (buttonClick)="primaryButtonClicked()">
      {{ config()?.primaryButtonText ?? '' }}
    </lib-button>
  </div>
</div>
